// src/features/system/MaintenanceScreen.tsx
import { useQuery } from "@tanstack/react-query";

import { session } from "@/auth/session";
import { Button } from "@/design-system";

import { systemStatusQuery } from "./api";

/** شاشة كاملة لمستخدمي المنظمات أثناء وضع الصيانة (الخادم يرد 503 على كل طلباتهم). تتحول تلقائياً عند انتهاء الصيانة. */
export function MaintenanceScreen() {
  const { data } = useQuery(systemStatusQuery);
  return (
    <div dir="rtl" className="app-bg flex min-h-screen items-center justify-center p-6" data-testid="maintenance-screen">
      <div className="glass flex max-w-[520px] flex-col items-center gap-4 p-9 text-center">
        <img src="/logo.png" alt="أضمن" className="h-16 w-16 rounded-2xl object-cover" style={{ boxShadow: "0 0 20px rgba(214,172,85,.6)" }} />
        <h1 className="m-0 text-[21px] font-semibold text-gold-xl">المنصة في وضع الصيانة</h1>
        <p className="m-0 text-[14px] leading-[1.9] text-ink-2">{data?.maintenance_message || "نعود قريباً"}</p>
        <p className="m-0 text-[12.5px] text-muted-2">بياناتك محفوظة وآمنة. تتحدث هذه الصفحة تلقائياً عند انتهاء الصيانة.</p>
        <Button onClick={() => { void session.signOut(); location.assign("/login"); }}>تسجيل الخروج</Button>
      </div>
    </div>
  );
}
